/** @format */

import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class OneSignalService {
  constructor() {}

  async onLoad(): Promise<any> {
    window.OneSignal = window.OneSignal || [];
    return new Promise((resolve) => {
      window.OneSignal.push(function () {
        resolve(window.OneSignal);
      });
    });
  }

  onInit(): void {
    this.onLoad().then((OneSignal) => {
      OneSignal.init({
        appId: '2f2cec88-be3f-4d3c-9f1d-118d7c74068a',
      });
    });
  }

  getId() {
    return new Promise<any>((resolve) => {
      this.onLoad().then((OneSignal) => {
        OneSignal.getUserId((userId) => {
          console.log('OneSignal User ID:', userId);
          resolve(userId);
        });
      });
    });
  }
}
